<!--
 * @Author: wbf
 * @LastEditTime: 2023-01-12 15:09:23
 * @Description: 绑定身份
-->
<template>
  <div>
    <NavBar
      :title="$t(`webapp.menus.${$route.meta.field}`)"
      :left-arrow="$route.meta.isShowArrow"
      @click-left="$router.back()"
      nav-bar-icon-color="#000"
      class="navbarSelf"
    ></NavBar>

    <div class="box">
      <div class="box-account">
        <div class="account-title">{{ $t("webapp.home.bind.common_user") }}</div>
        <div class="account-flex">
          <div>{{ currentAccount || $t("base.select") }}</div>
          <div v-if="defaultList.length" @click="accountShow = true">
            {{ $t("base.btn.change") }} <Icon name="arrow" />
          </div>
        </div>
      </div>

      <div class="box-account">
        <div class="account-title">{{ $t("webapp.home.bind.bind_user") }}</div>
        <template v-if="bindList.length">
          <div class="account-flex" v-for="(item, index) in bindList" :key="index">
            <div>{{ item.otherusername }}</div>
            <div @click="unbind(item)">{{ $t("base.btn.unbind") }}<Icon name="arrow" /></div>
          </div>
        </template>
        <div style="text-align: center; margin: 20px 0 10px" v-else>
          {{ $t("webapp.home.bind.no_user") }}
        </div>
      </div>

      <!-- <div style="margin-top: 30px">
      <Button round block type="info" @click="handleBind">绑定</Button>
    </div> -->

      <!-- 选择默认账户 -->
      <ActionSheet
        v-model="accountShow"
        :title="$t('webapp.home.bind.chose_user')"
        @cancel="accountShow = false"
      >
        <div class="sheet-content">
          <div class="sheetbg">
            <div class="sheet-flex">
              <div class="sheet-title">{{ $t("webapp.home.bind.change_user") }}</div>
              <!-- <div class="no-check" @click="defaultAccount = ''">
              不设默认帐户
            </div> -->
            </div>
            <RadioGroup v-model="defaultAccount">
              <div v-for="(item, index) in defaultList" :key="index" class="sheet-flex">
                <div>{{ item.username }}</div>
                <Radio :name="item.id"> </Radio>
              </div>
            </RadioGroup>
          </div>
          <div style="margin: 30px 0">
            <Button round block type="info" @click="handleCut">{{ $t("base.btn.save") }}</Button>
          </div>
        </div>
      </ActionSheet>

      <!-- 账号解绑:第三方绑定到我们这边的账户 -->
      <!-- <ActionSheet
      v-model="untieShow"
      title="账号解绑"
      @cancel="untieShow = false"
    >
      <div class="sheet-content">
        <div class="sheetbg">
          <div class="change-title sheet-title">验证要解绑账号的密码</div>
          <div class="change-title" style="color: #9f9f9f">{{ untieName }}</div>
          <Field
            v-model="untieMm"
            name="untieMm"
            placeholder="请输入密码"
            :show-error-message="false"
            :scroll-to-error="true"
            :rules="[{ required: true }]"
          />
        </div>
        <div style="margin: 30px 0">
          <Button round block type="info" @click="handleUntie">解绑</Button>
        </div>
      </div>
    </ActionSheet> -->
    </div>
  </div>
</template>

<script>
import { Dialog, Icon, Button, Toast, ActionSheet, RadioGroup, Radio, Field, NavBar } from "vant";
import { commonAPI } from "@/apis";
import { toast } from "@/utils/toast";

export default {
  name: "BindIdentity",
  components: { Dialog, Icon, Button, Toast, ActionSheet, RadioGroup, Radio, Field, NavBar },
  data() {
    return {
      accountShow: false,
      addAccount: false,
      // untieShow: false,
      changeForm: {},
      // untieMm: "",
      // untieName: "",
      // untieItem: {},
      bindList: [],
      defaultList: [],
      currentAccount: this.$t("webapp.home.bind.chose_user"),
      defaultAccount: ""
    };
  },
  created() {
    this.getDefaultList();
  },
  methods: {
    // 获取默认账户数据
    async getDefaultList() {
      this.loading = true;
      const { code, data, message } = await commonAPI.getAction("/config/profile/listOtherAccount");
      if (code == 0) {
        this.defaultList = data || [];
        // 需要查找到当前的默认账户
        const item = data.find(v => v.isCommon == 1);
        console.log(item);
        this.defaultAccount = item && item.id ? item.id : "";
        this.currentAccount =
          item && item.username ? item.username : this.$t("webapp.home.bind.chose_user");

        if (item && item.username) {
          this.getList();
        }
      } else {
        toast(message);
      }
      this.loading = false;
    },
    // 设置默认账户
    async handleEditDefault(username) {
      const { code, message } = await commonAPI.getAction(
        `/config/profile/editDefAccount/${username}`
      );
      if (code == 0) {
        toast(message);
        this.getDefaultList();
      } else {
        toast(message);
      }
    },
    // 切换默认账户
    handleCut() {
      console.log(888, this.defaultAccount);
      this.accountShow = false;
      this.currentAccount = this.defaultAccount
        ? this.defaultList.find(v => v.id == this.defaultAccount).username
        : "";
      console.log(this.currentAccount);
      this.handleEditDefault(this.currentAccount);
    },

    // 第三方已绑定账户列表
    async getList() {
      const { code, data, message } = await commonAPI.getAction(
        `/other/user/listByUserName/${this.currentAccount}`
      );
      if (code === 0) {
        this.bindList = data || [];
      } else {
        this.bindList = [];
        toast(message);
      }
    },
    handleBind() {
      this.$router.push({
        path: "/mbindAccount",
        query: {
          bindappid: "9e36af33-11b8-4208-a902-6bf7a635ecce",
          otherusername: "wbf"
        }
      });
    },

    //解绑
    unbind(item) {
      console.log(item);
      Dialog.confirm({
        title: this.$t("base.prompt.confirm_title"),
        message: this.$t("base.prompt.confirm_title").replace("$xxx", item.otherusername)
      })
        .then(async () => {
          // 解除绑定接口;
          const { code } = await commonAPI.postAction(`/other/user/delete/${item.id}`);
          if (code === 0) {
            toast(this.$t("base.prompt.unbind_success_tip"));
            this.getList();
          } else {
            toast(this.$t("base.prompt.unbind_failure_tip"));
          }
        })
        .catch(e => {
          console.log(e);
        });
    }
    // 新增账户
    // async handleEdit() {
    //   console.log(111, this.changeForm);
    // const { code, data } = await commonAPI.getAction("/config/socialsignon/add", this.changeForm);
    // if (code === 0) {
    //   toast("绑定成功");
    //   this.addAccount = false;
    //   this.changeForm = {};
    //   this.getList();
    // } else {
    //   toast("绑定失败");
    // }
    // },
    // 账号解绑
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/base.scss";
.box {
  padding: 0 15px;
  .box-account {
    background: #ffffff;
    box-shadow: 0px 1px 2px 1px rgba(228, 228, 228, 0.2);
    border-radius: 8px;
    margin-top: 10px;
    padding: 10px 15px;
    .account-title {
      font-size: 15px;
      font-weight: 600;
      color: #000;
      line-height: 40px;
      border-bottom: 1px solid #f5f5f5;
    }
    .account-flex {
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #666666;
      font-size: 14px;
      line-height: 40px;
    }
    .account-flex:not(:last-child) {
      border-bottom: 1px solid #f5f5f5;
    }
  }
  .sheet-content {
    background-color: #f7f7f7;
    padding: 12px 15px;
    .sheetbg {
      background: #fff;
      box-shadow: 0px 1px 2px 1px rgba(228, 228, 228, 0.2);
      border-radius: 8px;
    }
    .sheet-flex {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #f5f5f5;
      padding: 10px 15px;
    }
    .sheet-title {
      font-size: 15px;
      font-weight: 600;
      color: #000;
      line-height: 40px;
    }
    .no-check {
      color: #3c95ff;
    }
    .change-title {
      border-bottom: 1px solid #f5f5f5;
      padding: 10px 15px;
    }
  }
}
</style>
